import MomentUtils from "@date-io/moment";
import {
	KeyboardDatePicker,
	MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import type { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { useSearchParams } from "react-router-dom";
import { useFormsContext } from "../context/formsContext";

type Props = {};

export const EndFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const {
		state: {
			dataToGetFormInstances: { End, Start },
		},
	} = useFormsContext();

	const handleDateChange = (datePicker: MaterialUiPickersDate) => {
		if (datePicker && datePicker.isBefore(Start)) {
			return;
		}

		searchParams.set(
			"end",
			encodeURIComponent(datePicker!.toDate().toISOString()),
		);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<KeyboardDatePicker
				disableToolbar
				variant="inline"
				format="MM/DD/YYYY"
				id="date-picker-inline"
				style={{
					minWidth: "100%",
					borderTopLeftRadius: 3,
					borderTopRightRadius: 3,
				}}
				label="End"
				value={End}
				onChange={handleDateChange}
				KeyboardButtonProps={{
					"aria-label": "change date",
				}}
				minDate={Start}
			/>
		</MuiPickersUtilsProvider>
	);
};
